export default __webpack_public_path__ + "static/media/jayron.cdfa318d.jpg";